import { inject, observer } from "mobx-react";
import { useEffect } from "react";

import {
  Form, FormItem, InputPassword,
  InputText, useForm
  //@ts-ignore
} from '@microui/react-ui';
import { toJS } from "mobx";

const CreateAccount = ({ store }: any) => {
  const [form] = useForm();

  useEffect(() => {
    store.formCreatorAccount = form;
    form.setFieldsValue(toJS(store.defaultAccount));
  }, []);

  const handleSubmit = (values) => {
    store.registerAccount(values)
      .then((res) => {
        store.selectedAccount = {
          id: res.data,
          ...values
        };
        store.step = 1;
      });
  };

  return (
    <div className="max-w-[516px] w-full m-auto px-5 py-4">
      <Form
        form={form}
        onFinish={handleSubmit}
      >
        <span className='text-gray-500 block text-left mb-3'>Thông tin tài khoản</span>

        <FormItem
          name="username"
          label="Tài khoản"
          required
          rules={[{ type: 'user' }]}
        >
          <InputText placeholder='Nhập tài khoản' disabled={store.loading} />
        </FormItem>

        <FormItem
          name="email"
          label="Email"
          required
          rules={[{ type: 'email' }]}
        >
          <InputText placeholder='Nhập email' disabled={store.loading} />
        </FormItem>

        <FormItem
          label='Mật khẩu'
          name="password"
          required
          rules={[
            'password'
          ]}
        >
          <InputPassword placeholder='Nhập mật khẩu' disabled={store.loading} />
        </FormItem>

        <FormItem
          label='Nhập lại mật khẩu'
          name="repassword"
          required
          rules={[
            {
              validator: (rule, value, callback) => {
                if (value !== form.getFieldValue('password')) {
                  callback("Mật khẩu phải trùng khớp")
                }
                callback();
              }
            },
            'password'
          ]}
        >
          <InputPassword placeholder='Nhập lại mật khẩu' disabled={store.loading} />
        </FormItem>

        <span className='text-gray-500 block text-left mb-3 mt-5'>Thông tin cá nhân</span>

        <FormItem
          name="fullName"
          label="Họ và tên"
          required
          rules={[{ type: 'string' }]}
        >
          <InputText placeholder='Nhập tên đầy đủ của bạn' disabled={store.loading} />
        </FormItem>

        <FormItem
          name="phone"
          label="Số điện thoại"
        >
          <InputText placeholder='Nhập số điện thoại' disabled={store.loading} />
        </FormItem>

        <FormItem
          name="address"
          label="Địa chỉ"
        >
          <InputText placeholder='Nhập địa chỉ' disabled={store.loading} />
        </FormItem>

        <FormItem
          name="identityId"
          label="CMND/CCCD"
        >
          <InputText placeholder='Nhập CMND/CCCD' disabled={store.loading} />
        </FormItem>
      </Form>
    </div>
  )
}

export default inject('store')(observer(CreateAccount));